import React, { useState } from "react";
import politika from "./images/fotografije/politika.jpg";
import drugaSlika from "./images/fotografije/politika2.jpg";
import trecaSlika from "./images/fotografije/politika3.jpg";
import cetvrtaSlika from "./images/fotografije/politikinMagazin.jpg";
import petaSlika from "./images/fotografije/politikaVM.jpg";
import sestaSlika from "./images/fotografije/politikaMedina.jpg";
import sedmaSlika from "./images/fotografije/politikaOnama.jpg";
import osmaSlika from "./images/fotografije/politikaCarolija.jpg";
import devetaSlika from "./images/fotografije/politikaBiblioteka.jpg";
import desetaSlika from "./images/fotografije/preporukaPriboj.jpg";
import jedanaestaSlika from "./images/fotografije/preporukaCajetina.jpg";
import dvanaestaSlika from "./images/fotografije/preporukaCajetina2015.jpg";
import trinaestaSlika from "./images/fotografije/scenaMaste.jpg";

// Neka mesta
import bibliotekaRDA from './images/fotografije/nekaMesta/bibliotekaRDA.jpg'
import bibliotekaRDA2 from './images/fotografije/nekaMesta/bibliotekaRDA2.jpg'
import domKultureKrupanj from './images/fotografije/nekaMesta/domKultureKrupanj.jpg'
import Oktobar from './images/fotografije/nekaMesta/Oktobar.jpg'
import osAnta from './images/fotografije/nekaMesta/osAnta.jpg'
import osCakiLajos from './images/fotografije/nekaMesta/osCakiLajos.jpg'
import osDragoljubIlic from './images/fotografije/nekaMesta/osDragoljubIlic.jpg'
import osIvoLola from './images/fotografije/nekaMesta/osIvoLola.jpg'
import osIvoLolaSecond from './images/fotografije/nekaMesta/osIvoLolaSecond.jpg'
import osJordan from './images/fotografije/nekaMesta/osJordan.jpg'
import osMicaStojakoivic from './images/fotografije/nekaMesta/osMicaStojakovic.jpg'
import osMihajloMladenovic from './images/fotografije/nekaMesta/osMihajloMladenovic.jpg'
import osMilanRakic from './images/fotografije/nekaMesta/osMilanRakic.jpg'
import osMilivojeBorovic from './images/fotografije/nekaMesta/osMilivojeBorovic.jpg'
import osMiloradLabudovic from './images/fotografije/nekaMesta/osMiloradLabudovic.jpg'
import osRudovci from './images/fotografije/nekaMesta/osRudovci.jpg'
import osStanislavSremcevic from './images/fotografije/nekaMesta/osStanislavSremcevic.jpg'
import osStevanFilipovic from './images/fotografije/nekaMesta/osStevanFilipovic.jpg'
import osSvetiSava from './images/fotografije/nekaMesta/osSvetiSava.jpg'
import osSvetiSavaSecond from './images/fotografije/nekaMesta/osSvetiSavaSecond.jpg'
import puApril from './images/fotografije/nekaMesta/PU 11. April 2025 Cistologija.jpg'
import puBambi from './images/fotografije/nekaMesta/PU Bambi Bor 2015 Velika morska avantura.jpg'
import puBambiSecond from './images/fotografije/nekaMesta/PU Bambi Bor 2016 Potraga za blagom.jpg'
import puBambiLoznica from './images/fotografije/nekaMesta/PU Bambi Loznica 2016 Potraga za blagom.jpg'
import puBambiLoznicaSecond from './images/fotografije/nekaMesta/PU Bambi Loznica 2017 Aska i vuk.jpg'
import puBambiLoznicaThird from './images/fotografije/nekaMesta/PU Bambi Loznica 2019 Snezna kraljica.jpg'
import puCarolijaVrsac from './images/fotografije/nekaMesta/PU Carolija Vrsac 2018 Uspavana lepotica.jpg'
import puCarolijaVrsacSecond from './images/fotografije/nekaMesta/PU Carolija Vrsac 2020 Snezna kraljica.jpg'
import puDecijaRadostCuprija from './images/fotografije/nekaMesta/PU Decja radost Cuprija 2016 Caroloija na kraju predstave.jpg'
import puDecijaRadostSvilajnac from './images/fotografije/nekaMesta/PU Decja radost Svilajnac 2015.jpg'
import puDecijaRadostSvilajnacSecond from './images/fotografije/nekaMesta/PU Decja radost Svilajnac 2016 .jpg'
import puDrSimaMilosevic from './images/fotografije/nekaMesta/PU Dr. Sima Milosevic 2023 Carolija na kraju predstave.jpg'
import puDrSimaMilosevicZemun from './images/fotografije/nekaMesta/PU Dr. Sima Milosevic Zemun 2025 Velika morska avantura.jpg'
import puGalebPetrovac from './images/fotografije/nekaMesta/PU Galeb Petrovac 2017 Uspavana lepotica i maskirani princ.jpg'
import puVladicinHan from './images/fotografije/nekaMesta/PU i OS Vladicin Han 2018 Jednom ja tako....jpg'
import puJelicaObradovic from './images/fotografije/nekaMesta/PU Jelica Obradovic Mladenovac 2013.jpg'
import puKajaLjig from './images/fotografije/nekaMesta/PU Kaja Ljig 2018 Potraga za blagom.jpg'
import puLaneOsecina from './images/fotografije/nekaMesta/PU Lane Osecina 2018 Uspavana lepotica i maskirani princ.jpg'
import puMajskiCvet from './images/fotografije/nekaMesta/PU Majski cvet Veliko Gradiste 2025 Cistologija.jpg'
import puMarijaMuncan from './images/fotografije/nekaMesta/PU Marija Muncan Donji Milanovac i Majdanpek 2013 Carolija na kraju predstave.jpg'
import puNasaRadost from './images/fotografije/nekaMesta/PU Nasa radost Kovin 2016 Medina dijeta.jpg'
import puNasaRadostKovinSecond from './images/fotografije/nekaMesta/PU Nasa radost Kovin 2018 Potraga za blagom.jpg'
import puNasaRadostKovinThird from './images/fotografije/nekaMesta/PU Nasa radost Kovin 2020 Snezna kraljica.jpg'
import puNasaDeteVranje from './images/fotografije/nekaMesta/PU Nase dete Vranje 2018 Uspavana lepotica i maskirani princ.jpg'
import puNevenBajinaBasta from './images/fotografije/nekaMesta/PU Neven Bajina Basta 2011.jpg'
import puNevenBajinaBastaSecond from './images/fotografije/nekaMesta/PU Neven Bajina Basta 2019 Velika morska avantura.jpg'
import puNevenBajinaBastaThird from './images/fotografije/nekaMesta/PU Neven Bajina Basta 2025 Potraga za blagom.jpg'
import puNevenPriboj from './images/fotografije/nekaMesta/PU Neven Priboj 2016.jpg'
import puNevenPribojSecond from './images/fotografije/nekaMesta/PU Neven Priboj 2017 Jednom ja tako.jpg'
import puOlgaKosjeric from './images/fotografije/nekaMesta/PU Olga Grbic Kosjeric 2011.jpg'
import puOlgaKosjericSecond from './images/fotografije/nekaMesta/PU Olga Grbic Kosjeric 2012.jpg'
import puPcelicaApatin from './images/fotografije/nekaMesta/PU Pcelica Apatin 2011.jpg'
import puPcelicaApatinSecond from './images/fotografije/nekaMesta/PU Pcelica Apatin 2013.jpg'
import puPcelicaApatinThird from './images/fotografije/nekaMesta/PU Pcelica Apatin 2019 Uspavana lepotica i maskirani princ.jpg'
import puPcelicaApatinFourth from './images/fotografije/nekaMesta/PU Pcelica Apatin 2025 Cistologija.jpg'
import puPoletarac from './images/fotografije/nekaMesta/PU Poletarac Koceljeva 2015.jpg'
import puPoletaracSecond from './images/fotografije/nekaMesta/PU Poletarac Koceljeva 2017.jpg'
import puRadosnoDetinstvoNs from './images/fotografije/nekaMesta/PU Radosno detinjstvo Novi Sad 2012.jpg'
import puRadostCajetina from './images/fotografije/nekaMesta/PU Radost Cajetina 2011.jpg'
import puRadostCajetinaSecond from './images/fotografije/nekaMesta/PU Radost Cajetina 2016.jpg'
// na malim ekranima
import pedjolino from './images/fotografije/naMalimEkranima/Pedjolino 2016.jpg'
import studioB from './images/fotografije/naMalimEkranima/Studio B 2018 1.jpg'
import studioBSecond from './images/fotografije/naMalimEkranima/Studio B 2018 2.jpg'
import studioBThird from './images/fotografije/naMalimEkranima/Studio B 2018 4.jpg'



function Galerija() {
  // Svi fajlovi za galeriju

  const slike = [politika, drugaSlika, trecaSlika, cetvrtaSlika, petaSlika, sestaSlika, sedmaSlika, osmaSlika, devetaSlika, desetaSlika, jedanaestaSlika, dvanaestaSlika, trinaestaSlika];


  const slikeSecond = [bibliotekaRDA, bibliotekaRDA2, domKultureKrupanj, Oktobar, osAnta, osCakiLajos, osDragoljubIlic, osIvoLola, osIvoLolaSecond, osJordan, osMicaStojakoivic, osMihajloMladenovic, osMilanRakic, osMilivojeBorovic, osMiloradLabudovic, osRudovci, osStanislavSremcevic, osStevanFilipovic, osSvetiSava, osSvetiSavaSecond, puApril, puBambi, puBambiSecond, puBambiLoznica, puBambiLoznicaSecond, puBambiLoznicaThird, puCarolijaVrsac, puCarolijaVrsacSecond, puDecijaRadostCuprija, puDecijaRadostSvilajnac, puDecijaRadostSvilajnacSecond, puDrSimaMilosevic, puDrSimaMilosevicZemun, puGalebPetrovac, puVladicinHan, puJelicaObradovic, puKajaLjig, puLaneOsecina, puMajskiCvet, puMarijaMuncan, puNasaRadost, puNasaRadostKovinSecond, puNasaRadostKovinThird,puNasaDeteVranje , puNevenBajinaBasta, puNevenBajinaBastaSecond, puNevenBajinaBastaThird, puNevenPriboj, puNevenPribojSecond, puOlgaKosjeric, puOlgaKosjericSecond, puPcelicaApatin, puPcelicaApatinSecond, puPcelicaApatinThird, puPcelicaApatinFourth, puPoletarac, puPoletaracSecond, puRadosnoDetinstvoNs, puRadostCajetina, puRadostCajetinaSecond ]

  const slikeThird = [pedjolino, studioB, studioBSecond, studioBThird]

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenSecond, setIsOpenSecond] = useState(false);
  const [isOpenThird, setIsOpenThird] = useState(false);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndexSecond, setCurrentIndexSecond] = useState(0);
  const [currentIndexThird, setCurrentIndexThird] = useState(0);

  const openGalerija = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const openGalerijaSecond = (index) => {
    setCurrentIndexSecond(index);
    setIsOpenSecond(true);
  };

  const openGalerijaThird = (index) => {
    setCurrentIndexThird(index);
    setIsOpenThird(true);
  };

  const closeGalerija = () => {
    setIsOpen(false);
  };

  const closeGalerijaSecond = () => {
    setIsOpenSecond(false);
  };

  const closeGalerijaThird = () => {
    setIsOpenThird(false);
  };


  const nextSlika = () => {
    setCurrentIndex((prev) => (prev + 1) % slike.length);
  };
  const nextSlikaSecond = () => {
    setCurrentIndexSecond((prev) => (prev + 1) % slikeSecond.length);
  };
  const nextSlikaThird = () => {
    setCurrentIndexThird((prev) => (prev + 1) % slikeThird.length);
  };

  const prevSlika = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? slike.length - 1 : prev - 1
    );
  };
  const prevSlikaSecond = () => {
    setCurrentIndexSecond((prev) =>
      prev === 0 ? slikeSecond.length - 1 : prev - 1
    );
  };
  const prevSlikaThird = () => {
    setCurrentIndexThird((prev) =>
      prev === 0 ? slikeThird.length - 1 : prev - 1
    );
  };

  return (
    <div>
      <h2>Rekli su o nama</h2>

      {/* Prikazuje se samo politika kao thumbnail */}
      <div className="slike-grid">
        <img
          src={politika}
          alt="politika"
          className="thumbnail"
          onClick={() => openGalerija(0)}
        />
      </div>
      <h2>Neka mesta koja smo posetili</h2>
      <div className="slike-grid">
        <img
          src={bibliotekaRDA}
          alt="politika"
          className="thumbnail"
          onClick={() => openGalerijaSecond(0)}
        />
      </div>
      <h2>Na malim ekranima</h2>
      <div className="slike-grid">
        <img
          src={pedjolino}
          alt="StudioB"
          className="thumbnail"
          onClick={() => openGalerijaThird(0)}
        />
      </div>

      {/* Popup galerija */}
      {isOpen && (
        <div className="modal">
          <span className="close" onClick={closeGalerija}>✖</span>
          <span className="prev" onClick={prevSlika}>&#10094;</span>
          <img
            src={slike[currentIndex]}
            alt={`slika-${currentIndex}`}
            className="modal-content"
          />
          <span className="next" onClick={nextSlika}>&#10095;</span>
        </div>
      )}
         {isOpenSecond && (
        <div className="modal">
          <span className="close" onClick={closeGalerijaSecond}>✖</span>
          <span className="prev" onClick={prevSlikaSecond}>&#10094;</span>
          <img
            src={slikeSecond[currentIndexSecond]}
            alt={`slika-${currentIndexSecond}`}
            className="modal-content"
          />
          <span className="next" onClick={nextSlikaSecond}>&#10095;</span>
        </div>
      )}
        {isOpenThird && (
        <div className="modal">
          <span className="close" onClick={closeGalerijaThird}>✖</span>
          <span className="prev" onClick={prevSlikaThird}>&#10094;</span>
          <img
            src={slikeThird[currentIndexThird]}
            alt={`slika-${currentIndexThird}`}
            className="modal-content"
          />
          <span className="next" onClick={nextSlikaThird}>&#10095;</span>
        </div>
      )}
    </div>
  );
}

export default Galerija;
